import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { layerAction } from '../../reducers/layer';
import { Estimate } from '../../utils/util';
var EstimateAdded = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, item_id = _a.item_id, count = _a.count;
    var dispatch = useDispatch();
    var add = useCallback(function () {
        Estimate.addItem(item_id, count);
        dispatch(layerAction({
            name: 'estimate',
        }));
    }, []);
    return (React.createElement("button", { type: "button", className: className, onClick: add }, children));
};
export default EstimateAdded;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/estimate_added/index.tsx
// module id = 203
// module chunks = 0